import { IFeature } from '@/pages/home/components/features/feature.data.tsx';
import { FC } from 'react';

const FeatureColumns: FC<{ data: IFeature[] }> = ({ data }) => {
  return (
    <div className="container">
      <div className="grid grid-cols-3 gap-5">
        {data.map(feature => {
          return (
            <div key={feature.title.trim().toLowerCase()}>
              <div className="flex gap-5">
                <div className="w-[80px] h-[72px]">
                  <img
                    src={feature.icon}
                    alt={feature.title}
                    className="object-contain h-full!"
                  />
                </div>
                <div className="w-[calc(100%-80px)]">
                  <h3 className="text-xl mb-5">{feature.title}</h3>
                  <p className="text-sm leading-6">{feature.info}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FeatureColumns;
